import { render } from "./AboutFAQ.vue?vue&type=template&id=1e5ac3da"
import script from "./AboutFAQ.vue?vue&type=script&lang=js"
export * from "./AboutFAQ.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__